import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import articlePage from "@faire/web-api--source/routes/support/articles/articleId";

import { InstantAnswerContext, InstantAnswerScenario } from "../../types";

export const CheckAccountVerificationStatusIA: InstantAnswerBuilderFn = (
  strictLocalize,
  articles
) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    learnMoreLink: articles?.MyOrders.BUSINESS_PROFILE
      ? articlePage(articles.MyOrders.BUSINESS_PROFILE.id)
      : undefined,
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => VERIFY_YOUR_ACCOUNT(strictLocalize),
    getDescription: () => [IF_YOU_PROVIDED_ALL_REQUIRED_INFO(strictLocalize)],
  };
};

const VERIFY_YOUR_ACCOUNT = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "Please allow at least 1 business day for us to review your information",
    description: {
      text: "Title for the answer of Check account verification status issue",
    },
  });

const IF_YOU_PROVIDED_ALL_REQUIRED_INFO = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "If you provided all of the required information in the account verification form, you’ll receive an email as soon as we review it. We typically respond within 1 business day.",
  });
